export const ACCOUNT_AVATAR_SIZE = 32;
